import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'
import _imports_2 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-83129b94")

_pushScopeId("data-v-83129b94")
const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "absolute inset-y-0 right-0 flex items-center mr-3 w-4" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: "up"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  alt: "down"
}
const _hoisted_5 = { class: 
          `inline-block relative bottom-0 left-0 text-12px xxl:text-14px w-10/12`
         }
const _hoisted_6 = {
  class: "\n        w-full\n        bg-gray-lp-700\n        p-1\n        border border-t-0 border-gray-lp-400\n        rounded-b-md\n      ",
  style: `left:-1px`
}
const _hoisted_7 = {
  key: 0,
  class: "select-search py-1 overflow-y-auto"
}
const _hoisted_8 = { class: "flex flex-row" }
const _hoisted_9 = { class: "w-1/12" }
const _hoisted_10 = { class: "w-10/12 flex" }
const _hoisted_11 = { class: "w-10" }
const _hoisted_12 = {
  key: 1,
  class: "select-search py-3 overflow-y-auto text-center text-gray-500"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Apa yang anda cari tidak")
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" ditemukan atau tidak ada ")
const _hoisted_16 = {
  key: 0,
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: 
          `inline-block relative bottom-0 left-0 text-12px xxl:text-14px ${_ctx.prefixWidth}`
        
      }, [
        _createVNode("div", {
          class: 
            `bg-gray-lp-700 flex rounded-l border ${
              _ctx.error ? 'border-red-lp-800' : 'border-gray-lp-400'
            } text-black-lp-300 leading-tight px-2 py-2.5 xxl:py-2.5 font-normal`
          
        }, [
          (_ctx.flag)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                alt: _ctx.flag,
                class: "w-6",
                src: require(`@/app/ui/assets/svg/flag/${_ctx.flag}.svg`)
              }, null, 8, ["alt", "src"]))
            : _createCommentVNode("", true),
          _createVNode("input", {
            type: "text",
            onInput: _cache[1] || (_cache[1] = e => _ctx.onSearch(e.target.value)),
            value: _ctx.code,
            onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onOpenSearch && _ctx.onOpenSearch(...args))),
            onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onCloseSearch && _ctx.onCloseSearch(...args))),
            disabled: _ctx.disabled,
            onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.pasteText && _ctx.pasteText(...args))),
            class: 
              `w-full bg-gray-lp-700 truncate self-center align-middle focus:outline-none pl-1`
            ,
            ref: "selectSearch",
            "data-testid": _ctx.countryCodeTestId || undefined
          }, null, 40, ["value", "disabled", "data-testid"]),
          _withDirectives(_createVNode("div", _hoisted_2, [
            (_ctx.isOpenSearch)
              ? (_openBlock(), _createBlock("img", _hoisted_3))
              : (_openBlock(), _createBlock("img", _hoisted_4))
          ], 512), [
            [_vShow, _ctx.showChevron]
          ])
        ], 2)
      ], 2),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", {
          class: 
            `${
              _ctx.disabled ? 'bg-gray-lp-700' : 'bg-white'
            } rounded-r border-t border-r border-b ${
              _ctx.error ? 'border-red-lp-800' : 'border-gray-lp-400'
            } text-black-lp-300 leading-tight px-3 py-2.5 xxl:py-2.5 pr-8 font-normal`
          
        }, [
          _createVNode("input", {
            type: "text",
            onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.formatText($event))),
            maxlength: _ctx.maxLength,
            placeholder: _ctx.placeholder,
            value: _ctx.phone,
            onFocus: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
            disabled: _ctx.disabled,
            class: 
              `w-full truncate self-center align-middle focus:outline-none`
            ,
            "data-testid": _ctx.phoneTestId || undefined
          }, null, 40, ["maxlength", "placeholder", "value", "disabled", "data-testid"])
        ], 2)
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_6, [
      (_ctx.dataSearch.length)
        ? (_openBlock(), _createBlock("ul", _hoisted_7, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataSearch, (item, index) => {
              return (_openBlock(), _createBlock("li", {
                key: index,
                class: "max-w-full cursor-pointer py-2.5 hover:bg-gray-lp-100 p-1",
                onMousedown: () => _ctx.onChooseSearch(item)
              }, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("img", {
                      alt: item.name,
                      class: "w-6",
                      src: require(`@/app/ui/assets/svg/flag/${item.flag}.svg`)
                    }, null, 8, ["alt", "src"])
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, _toDisplayString(item.code), 1),
                    _createTextVNode(" " + _toDisplayString(`(${item.name})`), 1)
                  ])
                ])
              ], 40, ["onMousedown"]))
            }), 128))
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_12, [
            _hoisted_13,
            _hoisted_14,
            _hoisted_15
          ]))
    ], 512), [
      [_vShow, _ctx.isOpenSearch]
    ]),
    _createVNode("div", {
      class: 
        _ctx.error
          ? 'text-red-lp-100 text-12px xxl:text-14px pl-1 py-2 flex gap-x-2 items-center'
          : ''
      
    }, [
      (_ctx.error)
        ? (_openBlock(), _createBlock("img", _hoisted_16))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.errorCaption), 1)
    ], 2)
  ]))
})